// frontend/src/actions/adminActions.js
// frontend/src/actions/adminActions.js
import axios from 'axios';
import {
    adminLoginRequest,
    adminLoginSuccess,
    adminLoginFail,
    loadAdminRequest,
    loadAdminSuccess,
    loadAdminFail,
    clearError,
    adminLogout as adminLogoutAction
} from '../slices/adminSlice';

export const loginAdmin = (email, password) => async (dispatch) => {
    try {
        dispatch(adminLoginRequest());

        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        };

        const { data } = await axios.post('/api/v1/admin/login', 
            { email, password }, 
            config
        );

        if (data.success) {
            const adminData = {
                admin: data.user,
                token: data.token
            };

            localStorage.setItem('adminInfo', JSON.stringify(adminData));
            dispatch(adminLoginSuccess(adminData));
            return true;
        }

        dispatch(adminLoginFail('Login failed'));
        return false;
    } catch (error) {
        dispatch(adminLoginFail(error.response?.data?.message || 'Login failed'));
        return false;
    }
};

export const loadAdmin = () => async (dispatch) => {
    try {
        const adminInfo = localStorage.getItem('adminInfo');
        if (!adminInfo) {
            dispatch(loadAdminFail(null));
            return;
        }

        dispatch(loadAdminRequest());

        const config = {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json'
            }
        };

        const { data } = await axios.get('/api/v1/admin/profile', config);

        if (data.success) {
            dispatch(loadAdminSuccess(data.admin));
        } else {
            localStorage.removeItem('adminInfo');
            dispatch(loadAdminFail(null));
        }
    } catch (error) {
        localStorage.removeItem('adminInfo');
        dispatch(loadAdminFail(error.response?.data?.message));
    }
};

export const logoutAdmin = () => async (dispatch) => {
    try {
        await axios.get('/api/v1/admin/logout', { withCredentials: true });
    } catch (error) {
        console.error('Logout error:', error);
    } finally {
        localStorage.removeItem('adminInfo');
        dispatch(adminLogoutAction());
    }
};

export const clearAdminError = () => (dispatch) => {
    dispatch(clearError());
};